module.exports = __webpack_public_path__ + "static/media/IMG_3074.6f9282f2.JPG";